import React from 'react';
import { useFristApprovalOptional } from './FristApprovalContext';
import { FristApprovalCard } from './FristApprovalCard';

export interface FristApprovalDocumentMirrorProps {
  nextcloudPath?: string | null;
  nextcloudWebdavPath?: string | null;
  pbRecordId?: string | null;
  documentDisplayName?: string | null;
  className?: string;
}

/**
 * Dokument-Spiegel der Approval-Card (Slice 1) — gleiche `card_id`, synchron via Context.
 * Einbindung im Dokument-Editor (CustomerPortal); Export über DokumenteView.
 */
export const FristApprovalDocumentMirror: React.FC<FristApprovalDocumentMirrorProps> = ({
  nextcloudPath,
  nextcloudWebdavPath,
  pbRecordId,
  documentDisplayName,
  className = '',
}) => {
  const ctx = useFristApprovalOptional();
  if (!ctx) return null;

  const card = ctx.getCardForDocument({
    nextcloudPath,
    nextcloudWebdavPath,
    pbRecordId,
  });

  if (!card) return null;

  return (
    <div className={`shrink-0 px-3 pt-2 ${className}`} aria-live="polite">
      {documentDisplayName ? (
        <p className="text-[10px] text-slate-500 m-0 mb-1 truncate">
          Dokument: {documentDisplayName}
        </p>
      ) : null}
      <FristApprovalCard payload={card.payload} variant="mirror" />
    </div>
  );
};
